import findResult, {
  assignIfExists,
  assignValue,
  findMatch,
  newName,
} from '@/utils/resultsHelper';
import withDraft from '@/utils/draftHelper';
import { findWithUUID } from '@/utils/uuidHelper';
import fetchClausesCountsState from '../../profile/state/shared';
import pruneCohortErrors, {
  findCohort,
  assignEditCohortProps,
  uniqueDictionariesInClauses,
} from '../../state/shared';
import activeClause, { addUUIDsToCohortClause, clauseNames } from './state';
import actions from '../constants';

const updateClausePanels = withDraft((draft, action) => {
  const item = findCohort(draft, action);
  item.queries.forEach((query) => {
    if (findMatch(uniqueDictionariesInClauses(query), action.dictionaryCode)) {
      assignValue(query, 'activeDictionaryCode', action.dictionaryCode);
    }
  });
});

const showRenameClause = withDraft((draft, action) => {
  const item = findCohort(draft, action);
  const query = findWithUUID(item.queries, action.queryUUID);
  const clause = findWithUUID(query.clauses, action.clauseUUID);

  draft.activeClause.open = true;
  draft.activeClause.code = action.code;
  draft.activeClause.category = action.category;
  draft.activeClause.queryUUID = query.uuid;
  draft.activeClause.uuid = clause.uuid;
  draft.activeClause.name = clause.name;
  draft.activeClause.description = clause.description;
});

const hideRenameClause = withDraft((draft, action) => {
  if (!action.cancel) {
    const cohort = findResult(draft.cohorts, draft.activeClause.category, draft.activeClause.code);
    assignEditCohortProps(cohort, true);
    const query = findWithUUID(cohort.queries, draft.activeClause.queryUUID);
    const clause = findWithUUID(query.clauses, draft.activeClause.uuid);
    clause.name = draft.activeClause.name;
    clause.description = draft.activeClause.description;
  }
  draft.activeClause = activeClause();
});

const updateActiveClauseProperties = withDraft((draft, action) => {
  assignIfExists(draft.activeClause, action.properties);
  draft.activeClause.saveErrors = pruneCohortErrors(draft.activeClause.saveErrors, action);
});

const removeCohortClause = withDraft((draft, action) => {
  const item = findCohort(draft, action);
  assignEditCohortProps(item, true);

  const query = findWithUUID(item.queries, action.queryUUID);
  query.clauses = query.clauses.filter((r) => (r.uuid !== action.clauseUUID));
  fetchClausesCountsState(draft, action);
});

const cloneCohortClause = withDraft((draft, action) => {
  const item = findCohort(draft, action);
  assignEditCohortProps(item, true);

  const query = findWithUUID(item.queries, action.queryUUID);
  const clause = addUUIDsToCohortClause(findWithUUID(query.clauses, action.clauseUUID), false, true);
  clause.name = newName('Clause', clauseNames(query));
  query.clauses.push(clause);
  fetchClausesCountsState(draft, action);
});

export default {
  [actions.CLONE_COHORT_CLAUSE]: cloneCohortClause,
  [actions.HIDE_RENAME_CLAUSE]: hideRenameClause,
  [actions.REMOVE_COHORT_CLAUSE]: removeCohortClause,
  [actions.SHOW_RENAME_CLAUSE]: showRenameClause,
  [actions.UPDATE_ACTIVE_CLAUSE_PROPERTIES]: updateActiveClauseProperties,
  [actions.UPDATE_CLAUSE_PANELS]: updateClausePanels,
};
